// extracted by mini-css-extract-plugin
export default {"collectionTitle":"_16mvlhj","collectionName":"_sv91fg","collectionTeaser":"_172ncox"};